import React from 'react'
import { Parallax } from 'react-parallax'
import HeaderImg from "../../img/header-img.jpg"

function Hero() {
  return (
    <Parallax
        className="lg:h-screen"
        bgImage={HeaderImg}
        bgImageAlt="the cat"
        strength={400}
      >
        <div className="flex items-center justify-center mt-20 md:mt-24 mb-3 lg:m-0 lg:h-screen">
          <div className="md:w-4/5 mx-auto bg-white bg-opacity-15">
            <div className="text-center">
              <h1 className="text-6xl sm:text-8xl md:text-9xl poppins-bold text-white">ECOKAZ</h1>
              <span className="text-2xl sm:text-5xl md:text-6xl text-white poppins-bold">
                FOR AFRICA - MADAGASCAR
              </span>
            </div>
            <p className="text-lg sm:text-2xl poppins-bold text-white mt-5 md:mt-10 text-center tracking-wider">
              WELCOME-BIENVENUE-TONGASOA
            </p>
            <h3 className="text-2xl sm:text-3xl md:text-4xl uppercase poppins-bold text-lime-500 text-center mt-5 md:mt-10">
              "Fournisseur de matériaux de construction à base de déchets
              plastiques"
            </h3>
            {/* <div className="flex justify-center space-x-5 mt-10">
              <button
                className="flex items-center justify-center rounded px-8 py-2. bg-blue-800 text-white poppins-bold text-sm transition duration-300 hover:bg-white hover:text-blue-800 uppercase"
                onMouseEnter={() => setColorSav("#1e40af")}
                onMouseLeave={() => setColorSav("#ffffff")}
              >
                En savoir plus
                <HiMiniArrowLongDown color={colorSav} className="ms-2" />
              </button>
              <button
                className="flex items-center rounded px-8 py-2 bg-amber-500 text-white poppins-bold text-sm transition duration-300 border-2 border-amber-500 hover:border-amber-500 hover:text-amber-500 hover:bg-transparent uppercase"
                onMouseEnter={() => setColorCom("#FFBF00")}
                onMouseLeave={() => setColorCom("#ffffff")}
              >
                Commander
                <HiMiniArrowLongRight
                  color={colorCom}
                  className="ms-2 hover:text-amber-500"
                />
              </button>
            </div>

            <div className="flex justify-center space-x-5 mt-10">
              <button className="text-center flex items-center rounded-full font-bold text-xl transition duration-300 uppercase p-1">
                <FaChevronDown color={"#ffffff"} />
              </button>
            </div> */}
          </div>
        </div>
      </Parallax>
  )
}

export default Hero
